import { render, staticRenderFns } from "./multiAV.vue?vue&type=template&id=401b8afa&scoped=true&"
import script from "./multiAV.vue?vue&type=script&lang=js&"
export * from "./multiAV.vue?vue&type=script&lang=js&"
import style0 from "./multiAV.vue?vue&type=style&index=0&id=401b8afa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401b8afa",
  null
  
)

export default component.exports